"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFavoriteVehicleId = exports.deleteFavoriteVehicleIds = exports.addFavoriteVehicleId = exports.setFavoriteVehicleIds = exports.REMOVE_FAVORITE = exports.DELETE_FAVORITES = exports.SET_FAVORITES = exports.ADD_FAVORITE = exports.FAVORITE_VEHICLES_IDS = void 0;
exports.FAVORITE_VEHICLES_IDS = '[favorite Vehicle Ids]';
exports.ADD_FAVORITE = `${exports.FAVORITE_VEHICLES_IDS} ADD`;
exports.SET_FAVORITES = `${exports.FAVORITE_VEHICLES_IDS} SET`;
exports.DELETE_FAVORITES = `${exports.FAVORITE_VEHICLES_IDS} DELETE`;
exports.REMOVE_FAVORITE = `${exports.FAVORITE_VEHICLES_IDS} REMOVE`;
const setFavoriteVehicleIds = ({ vehicleIds }) => ({
    type: exports.SET_FAVORITES,
    payload: vehicleIds,
    meta: { feature: exports.FAVORITE_VEHICLES_IDS },
});
exports.setFavoriteVehicleIds = setFavoriteVehicleIds;
const addFavoriteVehicleId = ({ vehicleId }) => ({
    type: exports.ADD_FAVORITE,
    payload: vehicleId,
    meta: { feature: exports.FAVORITE_VEHICLES_IDS },
});
exports.addFavoriteVehicleId = addFavoriteVehicleId;
const deleteFavoriteVehicleIds = () => ({
    type: exports.DELETE_FAVORITES,
    payload: [],
    meta: { feature: exports.FAVORITE_VEHICLES_IDS },
});
exports.deleteFavoriteVehicleIds = deleteFavoriteVehicleIds;
const removeFavoriteVehicleId = ({ vehicleId }) => ({
    type: exports.REMOVE_FAVORITE,
    payload: vehicleId,
    meta: { feature: exports.FAVORITE_VEHICLES_IDS },
});
exports.removeFavoriteVehicleId = removeFavoriteVehicleId;
//# sourceMappingURL=favoriteVehicleIds.js.map